import React from 'react';

import { balance, figure, fundingSources } from './changeRequestFormat';

/**
 * A row's Source of funds · balance impact cell. It renders the funding split the
 * server calculated and works nothing out for itself. A decrease names where its
 * amount goes back, and a revenue increase what it adds to Event profit.
 */
export default function FundingCell({ funding = {}, category = null }) {
    const sources = fundingSources(funding, category);
    const hasImpact = funding.balance_before !== null && funding.balance_before !== undefined;
    const hasCentralImpact = funding.central_balance_before !== null && funding.central_balance_before !== undefined;

    return (
        <td>
            {sources.length === 0 ? (
                <span className="bc-dim">&mdash;</span>
            ) : (
                sources.map((source) => (
                    <div key={source.key} className="tw-whitespace-nowrap">
                        {sourceText(source)}
                    </div>
                ))
            )}

            {hasImpact &&
                (funding.at_approval ? (
                    <span className="bc-sub">
                        {$t('Balance {{before}} → {{after}} at approval', {
                            before: balance(funding.balance_before),
                            after: balance(funding.balance_after),
                        })}
                    </span>
                ) : (
                    <>
                        <span className="bc-sub">
                            {$t('This item: {{before}} → {{after}}', {
                                before: balance(funding.balance_before),
                                after: balance(funding.balance_after),
                            })}
                        </span>
                        {funding.cumulative_count > 0 && (
                            <span className="bc-sub">
                                {$t('Cumulative ({{index}} of {{count}}): {{remaining}} remaining', {
                                    index: funding.cumulative_index,
                                    count: funding.cumulative_count,
                                    remaining: balance(funding.cumulative_remaining),
                                })}
                            </span>
                        )}
                    </>
                ))}

            {/* A change funded from both pots affects both, and the pair above covers
                only the one the row is attributed to. */}
            {hasCentralImpact && (
                <span className="bc-sub">
                    {$t('Central contingency: {{before}} → {{after}}', {
                        before: balance(funding.central_balance_before),
                        after: balance(funding.central_balance_after),
                    })}
                </span>
            )}
        </td>
    );
}

function sourceText(source) {
    if (source.added) {
        return $t('{{source}} {{amount}} added', { source: source.label, amount: figure(source.amount) });
    }

    if (source.returned) {
        return $t('{{source}} {{amount}} returned', { source: source.label, amount: figure(source.amount) });
    }

    return `${source.label} ${figure(source.amount)}`;
}
